import { Typography } from '@mui/material'
import { Copy, CopyContainer } from '../../../../../common/copy'
import { Form } from '../../../../../common/Form/Form'
import Input from '../../../../../common/Input/Input'
import styles from './Telephone.module.scss'
import useTelephone from './useTelephone'
import { Button, Select } from '../../../../../common'
import HeaderContent from '../../../../HeaderContent/HeaderContent'
import BodyContent from '../../../../BodyContent/BodyContent'
import FooterContent from '../../../../FooterContent/FooterContent'

const Telephone = () => {
  const { exchanges, register, CallResponse, loading, error, handlers } =
    useTelephone()
  const { handleSubmit } = handlers

  return (
    <div className={styles.telephoneRoot}>
      <CopyContainer padding={{ top: 'small', left: 'large', right: 'medium' }}>
        <Copy stackSpacing="medium">
          <Typography variant="h2">Telephone</Typography>
        </Copy>
      </CopyContainer>
      <CopyContainer
        padding={{ top: 'small', left: 'medium', right: 'medium' }}
      >
        <Copy>
          <Form onSubmit={handleSubmit}>
            <div>
              <label>Exchange</label>
              <Select
                {...register('exchange')}
                options={exchanges.map((ex) => ({ value: ex, label: ex }))}
                fullWidth={true}
              />
            </div>

            <div>
              <Input
                label="Number"
                {...register('number', { required: true })}
              />
            </div>

            <div>
              <label>Message</label>
              <Input {...register('message')} />
            </div>

            <br />
            <Button type="submit" disabled={loading}>
              Dial
            </Button>
          </Form>

          {error && <Typography color="error">{error}</Typography>}
        </Copy>
      </CopyContainer>

      {/* Response */}
      {CallResponse && (
        <>
          {/* Header */}
          {CallResponse?.header && (
            <HeaderContent
              filePath={CallResponse?.filePath}
              contentBlock={CallResponse.header}
            />
          )}
          {/* Body */}
          {CallResponse?.body && (
            <CopyContainer padding={{ left: 'small' }}>
              <Copy stackSpacing="small">
                <BodyContent
                  filePath={CallResponse?.filePath}
                  contentBlock={CallResponse.body}
                />
              </Copy>
            </CopyContainer>
          )}
          {/* Reply Options */}
          <CopyContainer
            padding={{ left: 'small', right: 'small', bottom: 'xsmall' }}
          >
            <Copy stackSpacing="medium">
              <div>
                <Typography>{CallResponse.message}</Typography>
                {CallResponse.replyOptions &&
                  CallResponse.replyOptions.length > 0 && (
                    <ul>
                      {CallResponse.replyOptions.map((r, i) => (
                        <li key={i}>{r}</li>
                      ))}
                    </ul>
                  )}
              </div>
            </Copy>
          </CopyContainer>
          {/* Footer */}
          {CallResponse?.footer && (
            <FooterContent
              filePath={CallResponse?.filePath}
              contentBlock={CallResponse.footer}
            />
          )}
        </>
      )}
    </div>
  )
}

export default Telephone
